import { StyleSheet, View } from 'react-native';
import { ShimmerSkeleton } from '../../../components/animations/Skeleton';
import { HStack, VStack } from '../../../components/primitives';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

function AgentCardSkeleton() {
  return (
    <View style={styles.card}>
      <HStack spacing="md" align="start">
        <ShimmerSkeleton width={42} height={42} borderRadius={21} />
        <VStack spacing="xs" style={styles.body}>
          <HStack justify="between" align="center">
            <ShimmerSkeleton width="55%" height={15} borderRadius={4} />
            <ShimmerSkeleton width={72} height={20} borderRadius={tokens.radius.full} />
          </HStack>
          <ShimmerSkeleton width="80%" height={12} borderRadius={4} />
          <HStack spacing="sm" align="center" style={styles.metaRow}>
            <ShimmerSkeleton width={104} height={11} borderRadius={4} />
            <ShimmerSkeleton width={88} height={11} borderRadius={4} />
          </HStack>
        </VStack>
      </HStack>
    </View>
  );
}

export function AgentListSkeleton({
  count = 6,
  columns = 1,
}: Readonly<{ count?: number; columns?: number }>) {
  const rows = Array.from({ length: Math.ceil(count / columns) }, (_, rowIndex) =>
    Array.from({ length: columns }, (_, columnIndex) => rowIndex * columns + columnIndex),
  );

  return (
    <VStack spacing="md" accessible accessibilityRole="progressbar">
      {rows.map((row, rowIndex) => (
        <HStack key={`agent-skeleton-row-${String(rowIndex)}`} spacing="md">
          {row.map((index) =>
            index < count ? (
              <View key={`agent-skeleton-${String(index)}`} style={styles.gridItem}>
                <AgentCardSkeleton />
              </View>
            ) : (
              <View key={`agent-skeleton-placeholder-${String(index)}`} style={styles.gridItem} />
            ),
          )}
        </HStack>
      ))}
    </VStack>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.surface.row,
    borderRadius: tokens.radius.lg,
    borderWidth: 1,
    borderColor: colors.border.muted,
    padding: tokens.spacing.md,
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  metaRow: {
    marginTop: 2,
  },
  gridItem: {
    flex: 1,
    flexBasis: 0,
    minWidth: 0,
  },
});
